import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TaConstantsService {
  DatabaseData = {
    OptionGroups: {
      US_UPD_Group: { ID: "29CB4321-A304-45C6-9D48-BB649CF3CBB0" },
      Group_UPD: { ID: "4223A7BB-EB4B-4AD2-9271-D5BBFDE284E2" },
      AXH_Finish_Group: { ID: "6D3916AD-04F4-4D9B-97E9-5A1FCDE2DCA2" },
      US_Finish_Group: { ID: "111295C4-B75A-4435-B789-3CA594436937" },
    },
    Brands: {
      TA_Accents: { ID: "026FB9F7-3D9F-4A1E-BE73-1C5A3A35B463" },
      Alexa_Hampton: { ID: "37CDA835-EEB5-45A4-B132-4D505B1534F7" },
      Keno_Bros: { ID: "6D19B18B-BE99-403D-9BFC-5377E7130EBA" },
      Althorp_Living_History: { ID: "D9D7C23D-82B6-4470-B9AE-AF51AFBD7F4D" },
      TA_Studio: { ID: "87614FBC-9801-4312-A2D4-BC2F67C345AA" },
      Salone: { ID: "76CAF86D-B8A8-4416-9DA8-DB2A031F7D67" },
      Michael_Berman: { ID: "AE36B491-8722-4F65-BF00-EA910BF78745" },
      Upholstery: { ID: "52D2444F-4BC6-4540-8159-F0B8BD4423AC" },
      Theodore_Alexander: { ID: "D1483451-48E9-4FB4-BA11-FA8552084DFF" },
    },
    Collections: {
      The_Alexa_Hampton_Collection: { ID: "9E007F80-83DD-467A-92ED-21AF909E9F76" },
      THEO_by_Theodore_Alexander: { ID: "1B2729FF-64DC-4434-B3FC-1CE80D275929" },
      UPHOLESTERY_Collection: { ID: "484379F5-5CD4-40B5-C17A-08DC43081AD8" }
    },
    DATA_FOR_TESTING: [
      { id: '14178', categoryName: "Aiden Chair", sku: "5253", brandLogo: "assets/fd_logo.png", disablePrice: false, urlImage: '' },
      { id: '14177', categoryName: "Aiden Long Sofa", sku: "609-10", brandLogo: "assets/fd_logo.png", disablePrice: false, urlImage: '' },
      { id: '14196', categoryName: "Sasha Swivel Chair", sku: "5282", disablePrice: false, urlImage: '' },
      { id: '14176', categoryName: "Aiden Sofa", sku: "608-10", disablePrice: false, urlImage: '' },
      { id: '14191', categoryName: "Nob Hill Stool", sku: "8053", disablePrice: false, urlImage: '' },
      { id: '14190', categoryName: "Lia Side Chair", sku: "3001", disablePrice: false, urlImage: '' },
      { id: '14199', categoryName: "Joan Slipper Chair", sku: "5310", disablePrice: false, urlImage: '' },
      { id: '14172', categoryName: "Catalina Channel Arm 95' Sofa", sku: "TASU50149-95", disablePrice: false, urlImage: '' },
      { id: '14173', categoryName: "Catalina Channel Arm Club Chair", sku: "TASU50149-32", disablePrice: false, urlImage: '' },
      { id: '14194', categoryName: "Willoughby Chair", sku: "MB104", disablePrice: false, urlImage: '' },
      { id: '14183', categoryName: "Riley Upholstered Chair (Cushion Seat and Back)", sku: "5189", disablePrice: false, urlImage: '' },
      { id: '14174', categoryName: "Catalina Swivel Chair", sku: "TASU52149", disablePrice: false, urlImage: '' },
      { id: '14755', categoryName: "Aiden LAF Chaise", sku: "609-41", disablePrice: false, urlImage: '' },
      { id: '14755', categoryName: "Aiden RAF Chaise", sku: "609-42", disablePrice: false, urlImage: '' },
      { id: '14167', categoryName: "Ravenswood Sofa", sku: "TASU50101-85", disablePrice: false, urlImage: '' },
      { id: '14197', categoryName: "Brett Upholstered Chair", sku: "5260", disablePrice: false, urlImage: '' },
      { id: '14171', categoryName: "Catalina Channel Arm 85' Sofa", sku: "TASU50149-85", disablePrice: false, urlImage: '' },
      { id: '14200', categoryName: "Coupe Chaise", sku: "MB506-10", disablePrice: false, urlImage: '' },
      { id: '14186', categoryName: "Lela Upholstered Chair", sku: "5174", disablePrice: false, urlImage: '' },
      { id: '14198', categoryName: "The Althorp Wingback Upholstered Chair", sku: "A216", disablePrice: false, urlImage: '' },
      { id: '14187', categoryName: "The Regent's Visit Sofa II", sku: "A480-90", disablePrice: false, urlImage: '' },
      { id: '14188', categoryName: "The Regent's Visit Upholstered Chair", sku: "A280", disablePrice: false, urlImage: '' },
      { id: '14195', categoryName: "Jaxson Upholstered Chair", sku: "5176", disablePrice: false, urlImage: '' },
      { id: '14185', categoryName: "Kati Upholstered Chair (Well Trim)", sku: "5173", disablePrice: false, urlImage: '' },
      { id: '14193', categoryName: "The India Silk Bedroom Upholstered Chair", sku: "A214.5", disablePrice: false, urlImage: '' },
      { id: '14201', categoryName: "Fairfax Chair", sku: "5290", disablePrice: false, urlImage: '' },
      { id: '14184', categoryName: "Riley Tight Back Upholstered Chair (Tight Back)", sku: "5192", disablePrice: false, urlImage: '' },
      { id: '14202', categoryName: "Lafayette Chair", sku: "U3012-28", disablePrice: false, urlImage: '' },
      { id: '14168', categoryName: "Ravenswood Extended Sofa", sku: "TASU50101-95", disablePrice: false, urlImage: '' },
      { id: '14179', categoryName: "Aiden Dressmaker Chair", sku: "5251", disablePrice: false, urlImage: '' },
      { id: '14181', categoryName: "Selby Upholstered Chair", sku: "5198", disablePrice: false, urlImage: '' },
      { id: '14189', categoryName: "Lia Armchair", sku: "3002", disablePrice: false, urlImage: '' },
      { id: '14166', categoryName: "Ravenswood Chair", sku: "TASU50101-42", disablePrice: false, urlImage: '' },
    ],
    THEOData: [
      { "sku": "TASU50149-32" },
      { "sku": "TASU50148-34" },
      { "sku": "TASU50147-34" },
      { "sku": "TASU52149" },
      { "sku": "TASU50149" },
      { "sku": "TASU50149-31-52" },
      { "sku": "TASU50149-67-82" },
      { "sku": "TASU50149-53-94" },
      { "sku": "TASU50149-68-82" },
      { "sku": "TASU50149-54-94" },
      { "sku": "TASU50148-41-30" },
      { "sku": "TASU50148-67-82" },
      { "sku": "TASU50148-42-30" },
      { "sku": "TASU50148-68-82" },
      { "sku": "TASU50148" },
      { "sku": "TASU50147" },
      { "sku": "TASU50149-95" },
      { "sku": "TASU50149-85" },
      { "sku": "TASU50148-95" },
      { "sku": "TASU50147-95" },
      { "sku": "TASU50147-85" },
      { "sku": "TASU50148-85" },
      { "sku": "TASU50150-30" },
      { "sku": "TASU50151-30" },
      { "sku": "TASU52152" },
      { "sku": "TASU50150-63-59" },
      { "sku": "TASU50151-63-59" },
      { "sku": "TASU50150-67-87" },
      { "sku": "TASU50151-67-87" },
      { "sku": "TASU50150-53-95" },
      { "sku": "TASU50151-53-95" },
      { "sku": "TASU50151-64-59" },
      { "sku": "TASU50150-64-59" },
      { "sku": "TASU50150-68-87" },
      { "sku": "TASU50151-68-87" },
      { "sku": "TASU50150-54-95" },
      { "sku": "TASU50151-54-95" },
      { "sku": "TASU50150" },
      { "sku": "TASU50151" },
      { "sku": "TASU50150-90" },
      { "sku": "TASU50151-90" }
    ]
  }

  constructor() { }
}
